import Experience from '../Experience'
import GSAP from 'gsap'

export default class Events {
  constructor() {
    //setup
    this.experience = new Experience()
    this.camera = this.experience.camera

    //method
    this.navigation()
    this.control()
  }

  navigation() {
    const navBtn = document.querySelector('.navigation')
    const navBars = document.querySelectorAll('.navigationBar ul li')
    let tl = new GSAP.timeline({ paused: true, reversed: true })
    navBars.forEach(navBar => {
      tl.from(navBar, { x: 5, autoAlpha: 0, stagger: { each: 0.1, from: 'right' } }, '<=0.1')
    })

    navBtn.addEventListener('click', () => {
      tl.reversed() ? tl.play() : tl.reverse()
    })
  }
  control() {
    const ctrlBtn = document.querySelector('.control')
    const ctrlBars = document.querySelectorAll('.controlBar .toggle')
    let tl = new GSAP.timeline({ paused: true, reversed: true })
    ctrlBars.forEach(ctrlBar => {
      tl.from(ctrlBar, { x: 20, autoAlpha: 0, stagger: { each: 0.1, from: 'right' } }, '<=0.1')
    })

    ctrlBtn.addEventListener('click', () => {
      tl.reversed() ? tl.play() : tl.reverse()
    })
  }
}
